import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'light';
};

/** Renders real buyer reviews only — returns nothing while the list is empty. */
export function Testimonials({
  testimonials,
  title = 'What facilitators are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  if (testimonials.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-light';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-320" data-mp="2x1urml94r551">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-321" data-mp="2s1ykwe91szls">
        <div className="text-center" data-id="element-322" data-mp="2s3jfu4z9ykk6">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court-deep" data-id="element-323" data-mp="v96jpyljjtix">
            Practitioner to practitioner
          </p>
          <h2 className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-324" data-mp="qav8pkjifcz4">
            {title}
          </h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-325" data-mp="m62o01dvk1s9">{subtitle}</p>}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-326" data-mp="79260plhjl6z">
          {testimonials.map((item, i) => <figure key={i} className="flex flex-col rounded-2xl border border-line bg-white p-5 shadow-card" data-id="element-327" data-mp="c73phbmtpmiz" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-328" data-mp="zyiu5b22ofxe">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-line" data-id="element-329" data-mp="14xlq8602rbt8" /> : <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-court-deep text-[13px] font-bold text-white" aria-hidden="true" data-id="element-330" data-mp="1nm0kd25ov5y9">
                    {item.author.split(/\s+/).map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'MG'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-331" data-mp="1ej4uo3d71pmx">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-shuttle text-shuttle" aria-hidden="true" data-id="element-332" data-mp="19s6cey8nahh1" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm italic text-ink" data-id="element-333" data-mp="10rqbnwjadofv">“{item.quote}”</blockquote>
              <figcaption className="mt-auto pt-4 text-xs text-ink-soft" data-id="element-334" data-mp="10px3gct0yw5r">
                <span className="block text-[13px] font-bold not-italic text-ink" data-id="element-335" data-mp="vrvjlpnryst8">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}